import React from 'react';
import { Card, EmptyText, Link, Row, Stack, Text, Title } from 'library/ui';
import { useClient } from 'shared';
import { AvailableTeacher, PagingResult } from 'models';
import AvailableTeachersList from './AvailableTeachersList';
import ViewMoreTeachers from './ViewMoreTeachers';

export default function AvailableTeachers() {
    const { data: availableTeachers } = useClient<PagingResult<AvailableTeacher>>({
        url: `api/available-teachers/?page_size=3&page=1`,
    });

    const teachers = availableTeachers?.results ?? [];
    const hasMore = (availableTeachers?.num_pages ?? 0) > 1;

    return (
        <Card>
            <Stack gap="md">
                <Row justify="between" align="start" gap="md">
                    <Stack gap="sm">
                        <Title size="h2">Book Available Teachers</Title>
                        <Text size="sm" tone="secondary">
                            Teachers who&apos;ve marked availability for these days. They&apos;ll get a direct request
                            and must confirm before the shift is booked.
                        </Text>
                    </Stack>
                    {teachers.length > 0 && hasMore && (
                        <Link to="/available-teachers" size="sm" underline={false}>
                            View More Available Teachers &rarr;
                        </Link>
                    )}
                </Row>
                {teachers.length > 0 ? (
                    <AvailableTeachersList teachers={teachers} />
                ) : (
                    <Stack gap="sm" align="start">
                        <EmptyText padding="none">
                            We didn&apos;t find any teachers who entered availability near you, but you can still invite
                            teachers from the Teacher Showcase.
                        </EmptyText>
                        <ViewMoreTeachers />
                    </Stack>
                )}
            </Stack>
        </Card>
    );
}
